export default {"src":"/_next/static/media/landing-page-header.2d4e53ba.svg","height":529,"width":597};